<template>
  <div  class="w-100 row p-header-main" id="header">
        <div  class="w-100 row position-relative justify-content-end">
            <h3 class="w-100 p-header-title">{{this.$route.meta.pageTitle}}</h3>

            <div :class="{'remove-btn-show-menu':removeBtnShowMenu}" class="d-flex p-header-right">
              <img @click="toggleSidebar" class="p-header-hamburger-icon c-pointer" src="../../assets/svg/menu.svg" alt="">
            </div>

            <div :class="{'p-header-status-show-arrow':true}"  @click="backPage" class="p-header-back-main  d-flex p-1  p-header-left">
              <img  class="p-header-back c-pointer" src="../../assets/svg/go-back-left-arrow.svg"   alt="">
            </div>

        </div>
    </div>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    // statusShowArrow: { type: Boolean, default: true },
  },
  data() {
    return {
      removeBtnShowMenu : false,
    }
  },

  computed: {

  },

  mounted() {
    if (this.$route.name == 'login') {
      this.removeBtnShowMenu = true;
    }

  },

  methods: {
    backPage(){
      this.$router.back()
    },

    toggleSidebar(){
      if (this.$store.state.showSidebar) {
        this.$store.state.showSidebar = false;
      }
      else {
        this.$store.state.showSidebar = true;
      }

    },

  }

}
</script>
